"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var Tile_1 = __importDefault(require("@/frontend/react/components/Tile"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var InviteAcceptDecline_1 = __importDefault(require("./InviteAcceptDecline"));
var navLinkCss = function (theme) { return ({
    textDecoration: 'none',
    color: theme.palette.text.primary,
}); };
function InviteTile(_a) {
    var invite = _a.invite;
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, __assign({ to: "".concat(invite.id), css: navLinkCss }, { children: function (_a) {
            var isActive = _a.isActive;
            return ((0, jsx_runtime_1.jsxs)(Tile_1.default, __assign({ active: isActive }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", gap: 4, mt: 4 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(material_1.Avatar, { src: invite.initiatingUser.profile.profilePicture, alt: invite.initiatingUser.name }) }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ flexBasis: "60%" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", color: "primary" }, { children: invite.initiatingUser.name })), invite.messages && (0, html_react_parser_1.default)(invite.messages.map(function (message) { return message.content; }).join(' '))] }))] })), (0, jsx_runtime_1.jsx)(InviteAcceptDecline_1.default, { invite: invite, simple: true })] })));
        } })));
}
exports.default = InviteTile;
